import * as React from "react";
import { SvgIcon, ISvgIconProps } from "./SvgIcon";

export interface IAlethioIconProps extends ISvgIconProps {
}

export class AlethioIcon extends React.PureComponent<IAlethioIconProps> {
    render() {
        return (
            <SvgIcon size={40} viewBoxSize={400} >
                <path id="Selection"
                      fill="black" stroke="black" stroke-width="1"
                      d="M 22.70,280.00
           C 13.94,260.60 6.03,232.33 6.00,211.00
             6.00,211.00 6.00,186.00 6.00,186.00
             6.16,172.31 10.99,151.09 15.33,138.00
             34.76,79.50 79.43,34.19 138.00,14.67
             152.71,9.76 172.51,5.02 188.00,5.00
             188.00,5.00 212.00,5.00 212.00,5.00
             235.99,5.04 269.93,15.60 291.00,26.88
             301.24,32.37 310.88,39.02 320.00,46.21
             329.78,53.92 336.10,59.47 344.27,69.00
             347.57,72.84 351.14,75.87 352.00,81.00
             358.72,84.70 367.09,99.91 370.74,107.00
             372.91,111.20 374.47,113.17 374.00,118.00
             378.16,120.47 378.13,122.75 379.86,127.00
             382.57,133.70 386.05,143.98 387.39,151.00
             387.39,151.00 390.56,165.00 390.56,165.00
             394.96,192.10 394.18,220.93 387.01,247.41
             387.01,247.41 385.09,256.00 385.09,256.00
             385.09,256.00 378.90,273.00 378.90,273.00
             377.60,276.23 376.58,280.94 373.00,282.00
             373.18,285.26 373.49,287.05 370.00,288.00
             370.04,295.02 363.39,303.28 359.50,309.00
             347.17,327.15 332.19,342.02 315.00,355.55
             312.04,357.88 298.08,367.00 295.00,367.92
             293.25,368.30 292.67,368.09 291.00,367.92
             290.14,371.71 288.30,372.12 285.00,373.74
             279.86,376.28 271.61,380.68 266.00,380.00
             262.50,384.66 246.07,387.99 240.00,389.08
             229.69,390.94 222.93,392.98 212.00,393.00
             195.88,393.03 179.79,393.95 164.00,390.23
             164.00,390.23 145.00,385.83 145.00,385.83
             141.60,384.77 139.29,384.90 137.00,382.00
             133.70,382.44 133.02,382.80 131.00,380.00
             124.18,380.38 116.09,375.35 110.00,372.37
             88.20,361.70 73.92,348.97 57.01,331.99
             51.93,326.88 40.73,315.02 40.00,308.00
             33.16,303.64 26.14,287.64 22.70,280.00 Z
           M 208.00,12.87
           C 208.00,12.87 189.00,12.87 189.00,12.87
             189.00,12.87 169.00,15.72 169.00,15.72
             169.00,15.72 153.00,18.00 153.00,18.00
             153.00,18.00 155.00,19.00 155.00,19.00
             155.00,19.00 144.28,20.46 144.28,20.46
             144.28,20.46 134.00,23.00 134.00,23.00
             134.00,23.00 135.00,25.00 135.00,25.00
             135.00,25.00 132.00,24.00 132.00,24.00
             129.34,26.41 128.62,26.95 125.00,27.00
             121.93,29.77 120.16,30.77 116.00,31.00
             116.00,31.00 116.00,33.00 116.00,33.00
             116.00,33.00 114.00,32.00 114.00,32.00
             114.00,32.00 109.00,35.00 109.00,35.00
             105.97,38.23 98.36,43.33 94.00,44.00
             94.00,44.00 68.17,66.58 68.17,66.58
             68.17,66.58 49.00,87.00 49.00,87.00
             48.49,89.49 48.44,89.42 46.00,90.00
             45.85,93.43 45.47,95.00 42.00,96.00
             42.00,96.00 43.00,99.00 43.00,99.00
             43.00,99.00 36.00,107.00 36.00,107.00
             36.00,107.00 27.86,125.17 27.86,125.17
             27.86,125.17 26.00,126.00 26.00,126.00
             26.17,133.62 19.45,147.07 17.68,155.83
             17.68,155.83 13.67,182.00 13.67,182.00
             13.67,182.00 13.00,201.00 13.00,201.00
             13.00,201.00 14.15,213.00 14.15,213.00
             14.15,213.00 14.15,225.00 14.15,225.00
             14.15,225.00 15.96,232.00 15.96,232.00
             19.46,250.68 23.24,260.60 30.74,278.00
             30.74,278.00 41.00,299.00 41.00,299.00
             41.00,299.00 50.45,311.00 50.45,311.00
             50.45,311.00 74.00,336.83 74.00,336.83
             74.00,336.83 99.00,355.66 99.00,355.66
             99.00,355.66 113.00,365.00 113.00,365.00
             117.16,365.23 129.96,371.10 133.00,374.00
             138.30,374.19 141.49,374.86 145.00,379.00
             150.49,377.18 155.64,379.76 161.00,380.88
             161.00,380.88 180.00,384.00 180.00,384.00
             180.00,384.00 178.00,384.00 178.00,384.00
             178.00,384.00 178.00,385.00 178.00,385.00
             178.00,385.00 201.00,385.00 201.00,385.00
             201.00,385.00 214.00,384.16 214.00,384.16
             214.00,384.16 220.00,384.16 220.00,384.16
             220.00,384.16 217.00,383.00 217.00,383.00
             217.00,383.00 237.00,380.88 237.00,380.88
             237.00,380.88 253.00,378.00 253.00,378.00
             256.01,375.23 267.96,371.19 272.00,371.00
             272.00,371.00 288.00,361.00 288.00,361.00
             288.00,361.00 290.00,363.00 290.00,363.00
             290.00,363.00 291.00,362.00 291.00,362.00
             291.00,362.00 290.00,360.00 290.00,360.00
             290.00,360.00 297.00,358.00 297.00,358.00
             297.00,358.00 321.00,338.95 321.00,338.95
             323.87,336.42 327.13,334.81 328.00,331.00
             328.00,331.00 333.00,331.00 333.00,331.00
             333.00,331.00 333.61,327.28 333.61,327.28
             333.61,327.28 349.00,310.00 349.00,310.00
             350.01,305.45 356.41,297.04 360.00,294.00
             360.26,290.24 361.24,289.43 364.00,287.00
             364.21,282.36 369.95,270.45 373.00,267.00
             372.91,260.55 377.79,250.75 379.39,244.28
             381.14,237.23 379.48,231.56 385.00,226.00
             382.43,218.97 383.97,218.24 384.00,211.00
             384.00,211.00 384.00,170.00 384.00,170.00
             381.38,168.87 381.32,165.63 380.80,163.00
             380.80,163.00 379.48,153.20 379.48,153.20
             378.25,147.76 375.78,145.16 376.00,139.00
             376.00,139.00 373.00,131.00 373.00,131.00
             373.00,131.00 366.74,118.99 366.74,118.99
             366.74,118.99 360.00,104.00 360.00,104.00
             360.00,104.00 351.39,92.42 351.39,92.42
             351.39,92.42 342.00,78.00 342.00,78.00
             342.00,78.00 327.00,64.03 327.00,64.03
             327.00,64.03 305.00,46.20 305.00,46.20
             305.00,46.20 291.00,36.00 291.00,36.00
             287.24,35.74 286.43,34.76 284.00,32.00
             279.53,31.81 278.17,31.15 275.00,28.00
             271.35,27.98 264.34,24.50 260.05,23.11
             250.64,20.07 229.20,13.68 220.00,15.00
             220.00,15.00 221.00,12.87 221.00,12.87
             221.00,12.87 208.00,12.87 208.00,12.87 Z
           M 141.00,15.00
           C 141.00,15.00 142.00,16.00 142.00,16.00
             142.00,16.00 142.00,15.00 142.00,15.00
             142.00,15.00 141.00,15.00 141.00,15.00 Z
           M 265.00,23.00
           C 265.00,23.00 266.00,24.00 266.00,24.00
             266.00,24.00 266.00,23.00 266.00,23.00
             266.00,23.00 265.00,23.00 265.00,23.00 Z
           M 283.00,24.00
           C 283.00,24.00 284.00,25.00 284.00,25.00
             284.00,25.00 284.00,24.00 284.00,24.00
             284.00,24.00 283.00,24.00 283.00,24.00 Z
           M 281.00,28.00
           C 281.00,28.00 282.00,29.00 282.00,29.00
             282.00,29.00 282.00,28.00 282.00,28.00
             282.00,28.00 281.00,28.00 281.00,28.00 Z
           M 101.00,34.00
           C 101.00,34.00 102.00,35.00 102.00,35.00
             102.00,35.00 102.00,34.00 102.00,34.00
             102.00,34.00 101.00,34.00 101.00,34.00 Z
           M 301.00,34.00
           C 301.00,34.00 302.00,35.00 302.00,35.00
             302.00,35.00 302.00,34.00 302.00,34.00
             302.00,34.00 301.00,34.00 301.00,34.00 Z
           M 295.00,35.00
           C 295.00,35.00 296.00,36.00 296.00,36.00
             296.00,36.00 296.00,35.00 296.00,35.00
             296.00,35.00 295.00,35.00 295.00,35.00 Z
           M 87.56,85.74
           C 91.25,84.25 101.48,86.32 104.40,83.40
             108.67,79.14 102.24,72.29 110.05,66.52
             122.43,57.37 143.00,48.68 158.00,44.97
             158.00,44.97 167.00,42.47 167.00,42.47
             167.00,42.47 200.00,39.32 200.00,39.32
             200.00,39.32 232.00,42.68 232.00,42.68
             269.82,51.24 303.83,72.91 327.11,104.00
             342.26,124.24 350.70,146.40 355.31,171.00
             356.78,178.85 357.99,182.66 358.00,191.00
             358.00,191.00 358.00,207.00 358.00,207.00
             357.99,215.79 357.06,216.86 355.61,225.00
             355.61,225.00 354.33,234.00 354.33,234.00
             351.10,249.13 343.30,267.72 335.40,281.00
             310.01,323.67 263.66,353.46 214.00,357.09
             214.00,357.09 204.00,358.00 204.00,358.00
             170.88,358.38 138.84,350.68 111.00,332.11
             77.30,309.62 52.54,274.67 43.66,235.00
             39.48,216.30 39.97,207.56 40.00,189.00
             40.02,176.58 45.62,152.55 50.44,141.00
             52.57,135.87 53.60,131.58 57.00,127.00
             57.00,127.00 56.00,135.00 56.00,135.00
             56.00,135.00 87.00,136.00 87.00,136.00
             87.00,136.00 87.00,106.00 87.00,106.00
             87.00,106.00 70.00,106.00 70.00,106.00
             72.69,100.91 82.43,87.81 87.56,85.74 Z
           M 98.00,41.00
           C 98.00,41.00 99.00,42.00 99.00,42.00
             99.00,42.00 99.00,41.00 99.00,41.00
             99.00,41.00 98.00,41.00 98.00,41.00 Z
           M 90.00,42.00
           C 90.00,42.00 91.00,43.00 91.00,43.00
             91.00,43.00 91.00,42.00 91.00,42.00
             91.00,42.00 90.00,42.00 90.00,42.00 Z
           M 89.00,47.00
           C 89.00,47.00 90.00,48.00 90.00,48.00
             90.00,48.00 90.00,47.00 90.00,47.00
             90.00,47.00 89.00,47.00 89.00,47.00 Z
           M 76.00,51.00
           C 76.00,51.00 77.00,52.00 77.00,52.00
             77.00,52.00 77.00,51.00 77.00,51.00
             77.00,51.00 76.00,51.00 76.00,51.00 Z
           M 321.00,55.00
           C 321.00,55.00 322.00,56.00 322.00,56.00
             322.00,56.00 322.00,55.00 322.00,55.00
             322.00,55.00 321.00,55.00 321.00,55.00 Z
           M 332.00,58.00
           C 332.00,58.00 333.00,59.00 333.00,59.00
             333.00,59.00 333.00,58.00 333.00,58.00
             333.00,58.00 332.00,58.00 332.00,58.00 Z
           M 72.00,59.00
           C 72.00,59.00 73.00,60.00 73.00,60.00
             73.00,60.00 73.00,59.00 73.00,59.00
             73.00,59.00 72.00,59.00 72.00,59.00 Z
           M 327.00,63.00
           C 327.00,63.00 328.00,64.00 328.00,64.00
             328.00,64.00 328.00,63.00 328.00,63.00
             328.00,63.00 327.00,63.00 327.00,63.00 Z
           M 88.60,67.02
           C 90.49,65.52 98.34,66.00 101.00,66.00
             101.00,66.00 101.00,80.00 101.00,80.00
             101.00,80.00 87.00,80.00 87.00,80.00
             87.00,77.06 86.27,68.87 88.60,67.02 Z
           M 109.00,71.00
           C 109.00,71.00 110.00,72.00 110.00,72.00
             110.00,72.00 110.00,71.00 110.00,71.00
             110.00,71.00 109.00,71.00 109.00,71.00 Z
           M 50.00,85.00
           C 50.00,85.00 51.00,86.00 51.00,86.00
             51.00,86.00 51.00,85.00 51.00,85.00
             51.00,85.00 50.00,85.00 50.00,85.00 Z
           M 70.00,85.00
           C 70.00,85.00 70.00,93.00 70.00,93.00
             70.00,93.00 62.00,93.00 62.00,93.00
             62.00,93.00 62.00,85.00 62.00,85.00
             62.00,85.00 70.00,85.00 70.00,85.00 Z
           M 348.00,87.00
           C 348.00,87.00 349.00,88.00 349.00,88.00
             349.00,88.00 349.00,87.00 349.00,87.00
             349.00,87.00 348.00,87.00 348.00,87.00 Z
           M 356.00,88.00
           C 356.00,88.00 357.00,89.00 357.00,89.00
             357.00,89.00 357.00,88.00 357.00,88.00
             357.00,88.00 356.00,88.00 356.00,88.00 Z
           M 150.00,101.00
           C 149.86,93.51 147.74,94.01 141.00,94.00
             141.00,94.00 97.00,94.00 97.00,94.00
             97.00,94.00 97.00,136.00 97.00,136.00
             96.97,138.64 95.56,145.23 97.59,146.79
             99.23,148.05 109.45,148.00 112.00,148.00
             124.65,148.02 137.45,148.66 150.00,147.00
             150.00,147.00 150.00,101.00 150.00,101.00 Z
           M 251.74,160.01
           C 253.58,161.50 261.40,161.00 264.00,161.00
             264.00,161.00 295.00,161.00 295.00,161.00
             303.66,160.95 303.99,160.32 304.00,152.00
             304.00,152.00 304.00,101.00 304.00,101.00
             303.86,93.51 301.74,94.01 295.00,94.00
             295.00,94.00 161.00,94.00 161.00,94.00
             161.00,94.00 160.00,133.00 160.00,133.00
             160.00,136.07 159.32,144.28 161.60,146.31
             163.35,147.87 170.37,147.00 173.00,147.00
             173.00,147.00 223.00,147.00 223.00,147.00
             230.76,147.00 243.96,146.29 251.00,148.00
             250.15,150.98 248.92,157.73 251.74,160.01 Z
           M 355.00,97.00
           C 355.00,97.00 356.00,98.00 356.00,98.00
             356.00,98.00 356.00,97.00 356.00,97.00
             356.00,97.00 355.00,97.00 355.00,97.00 Z
           M 361.00,98.00
           C 361.00,98.00 362.00,99.00 362.00,99.00
             362.00,99.00 362.00,98.00 362.00,98.00
             362.00,98.00 361.00,98.00 361.00,98.00 Z
           M 357.00,99.00
           C 357.00,99.00 358.00,100.00 358.00,100.00
             358.00,100.00 358.00,99.00 358.00,99.00
             358.00,99.00 357.00,99.00 357.00,99.00 Z
           M 39.00,101.00
           C 39.00,101.00 40.00,102.00 40.00,102.00
             40.00,102.00 40.00,101.00 40.00,101.00
             40.00,101.00 39.00,101.00 39.00,101.00 Z
           M 62.99,111.74
           C 65.19,109.02 79.17,110.00 83.00,110.00
             83.00,110.00 83.00,131.00 83.00,131.00
             83.00,131.00 62.00,131.00 62.00,131.00
             62.00,127.63 61.33,113.79 62.99,111.74 Z
           M 31.00,112.00
           C 31.00,112.00 32.00,113.00 32.00,113.00
             32.00,113.00 32.00,112.00 32.00,112.00
             32.00,112.00 31.00,112.00 31.00,112.00 Z
           M 378.00,132.00
           C 378.00,132.00 379.00,133.00 379.00,133.00
             379.00,133.00 379.00,132.00 379.00,132.00
             379.00,132.00 378.00,132.00 378.00,132.00 Z
           M 54.00,133.00
           C 54.00,133.00 55.00,134.00 55.00,134.00
             55.00,134.00 55.00,133.00 55.00,133.00
             55.00,133.00 54.00,133.00 54.00,133.00 Z
           M 23.00,134.00
           C 23.00,134.00 24.00,135.00 24.00,135.00
             24.00,135.00 24.00,134.00 24.00,134.00
             24.00,134.00 23.00,134.00 23.00,134.00 Z
           M 375.00,136.00
           C 375.00,136.00 376.00,137.00 376.00,137.00
             376.00,137.00 376.00,136.00 376.00,136.00
             376.00,136.00 375.00,136.00 375.00,136.00 Z
           M 383.00,149.00
           C 383.00,149.00 384.00,150.00 384.00,150.00
             384.00,150.00 384.00,149.00 384.00,149.00
             384.00,149.00 383.00,149.00 383.00,149.00 Z
           M 148.98,159.60
           C 147.41,157.62 143.30,158.00 141.00,158.00
             141.00,158.00 105.00,158.00 105.00,158.00
             92.31,158.09 96.98,164.32 97.00,179.00
             97.00,179.00 97.00,211.00 97.00,211.00
             97.00,213.66 96.52,221.51 98.02,223.40
             99.59,225.38 103.70,225.00 106.00,225.00
             106.00,225.00 251.00,225.00 251.00,225.00
             249.46,230.41 249.46,241.59 251.00,247.00
             244.04,248.69 231.61,248.00 224.00,248.00
             224.00,248.00 174.00,248.00 174.00,248.00
             174.00,248.00 115.00,248.00 115.00,248.00
             98.10,248.00 96.63,246.68 97.00,254.00
             97.00,254.00 97.00,260.00 97.00,260.00
             97.00,260.00 97.00,290.00 97.00,290.00
             96.97,292.10 96.14,297.98 97.00,299.40
             98.46,301.38 102.86,301.00 105.00,300.95
             105.00,300.95 240.00,300.95 240.00,300.95
             240.00,300.95 284.00,300.95 284.00,300.95
             286.70,301.00 300.29,301.56 301.69,300.95
             304.46,299.31 303.99,294.69 304.00,292.00
             304.00,292.00 304.00,200.00 304.00,200.00
             304.00,200.00 304.00,180.00 304.00,180.00
             304.00,178.06 304.25,174.28 303.01,172.74
             301.30,170.62 296.50,171.00 294.00,171.00
             294.00,171.00 150.00,171.00 150.00,171.00
             150.00,168.46 150.44,161.45 148.98,159.60 Z
           M 48.00,167.00
           C 48.00,167.00 49.00,168.00 49.00,168.00
             49.00,168.00 49.00,167.00 49.00,167.00
             49.00,167.00 48.00,167.00 48.00,167.00 Z
           M 385.00,243.00
           C 385.00,243.00 386.00,244.00 386.00,244.00
             386.00,244.00 386.00,243.00 386.00,243.00
             386.00,243.00 385.00,243.00 385.00,243.00 Z
           M 18.00,266.00
           C 18.00,266.00 19.00,267.00 19.00,267.00
             19.00,267.00 19.00,266.00 19.00,266.00
             19.00,266.00 18.00,266.00 18.00,266.00 Z
           M 20.00,270.00
           C 20.00,270.00 21.00,271.00 21.00,271.00
             21.00,271.00 21.00,270.00 21.00,270.00
             21.00,270.00 20.00,270.00 20.00,270.00 Z
           M 376.00,275.00
           C 376.00,275.00 377.00,276.00 377.00,276.00
             377.00,276.00 377.00,275.00 377.00,275.00
             377.00,275.00 376.00,275.00 376.00,275.00 Z
           M 361.00,293.00
           C 361.00,293.00 362.00,294.00 362.00,294.00
             362.00,294.00 362.00,293.00 362.00,293.00
             362.00,293.00 361.00,293.00 361.00,293.00 Z
           M 36.00,294.00
           C 36.00,294.00 37.00,295.00 37.00,295.00
             37.00,295.00 37.00,294.00 37.00,294.00
             37.00,294.00 36.00,294.00 36.00,294.00 Z
           M 356.00,298.00
           C 356.00,298.00 357.00,299.00 357.00,299.00
             357.00,299.00 357.00,298.00 357.00,298.00
             357.00,298.00 356.00,298.00 356.00,298.00 Z
           M 42.00,301.00
           C 42.00,301.00 43.00,302.00 43.00,302.00
             43.00,302.00 43.00,301.00 43.00,301.00
             43.00,301.00 42.00,301.00 42.00,301.00 Z
           M 43.00,302.00
           C 43.00,302.00 44.00,303.00 44.00,303.00
             44.00,303.00 44.00,302.00 44.00,302.00
             44.00,302.00 43.00,302.00 43.00,302.00 Z
           M 41.00,303.00
           C 41.00,303.00 42.00,304.00 42.00,304.00
             42.00,304.00 42.00,303.00 42.00,303.00
             42.00,303.00 41.00,303.00 41.00,303.00 Z
           M 39.00,306.00
           C 39.00,306.00 40.00,307.00 40.00,307.00
             40.00,307.00 40.00,306.00 40.00,306.00
             40.00,306.00 39.00,306.00 39.00,306.00 Z
           M 45.00,308.00
           C 45.00,308.00 46.00,309.00 46.00,309.00
             46.00,309.00 46.00,308.00 46.00,308.00
             46.00,308.00 45.00,308.00 45.00,308.00 Z
           M 353.00,310.00
           C 353.00,310.00 354.00,311.00 354.00,311.00
             354.00,311.00 354.00,310.00 354.00,310.00
             354.00,310.00 353.00,310.00 353.00,310.00 Z
           M 340.00,324.00
           C 340.00,324.00 341.00,325.00 341.00,325.00
             341.00,325.00 341.00,324.00 341.00,324.00
             341.00,324.00 340.00,324.00 340.00,324.00 Z
           M 345.00,324.00
           C 345.00,324.00 346.00,325.00 346.00,325.00
             346.00,325.00 346.00,324.00 346.00,324.00
             346.00,324.00 345.00,324.00 345.00,324.00 Z
           M 342.00,328.00
           C 342.00,328.00 343.00,329.00 343.00,329.00
             343.00,329.00 343.00,328.00 343.00,328.00
             343.00,328.00 342.00,328.00 342.00,328.00 Z
           M 340.00,330.00
           C 340.00,330.00 341.00,331.00 341.00,331.00
             341.00,331.00 341.00,330.00 341.00,330.00
             341.00,330.00 340.00,330.00 340.00,330.00 Z
           M 324.00,336.00
           C 324.00,336.00 325.00,337.00 325.00,337.00
             325.00,337.00 325.00,336.00 325.00,336.00
             325.00,336.00 324.00,336.00 324.00,336.00 Z
           M 72.00,342.00
           C 72.00,342.00 73.00,343.00 73.00,343.00
             73.00,343.00 73.00,342.00 73.00,342.00
             73.00,342.00 72.00,342.00 72.00,342.00 Z
           M 77.00,343.00
           C 77.00,343.00 78.00,344.00 78.00,344.00
             78.00,344.00 78.00,343.00 78.00,343.00
             78.00,343.00 77.00,343.00 77.00,343.00 Z
           M 87.00,348.00
           C 87.00,348.00 88.00,349.00 88.00,349.00
             88.00,349.00 88.00,348.00 88.00,348.00
             88.00,348.00 87.00,348.00 87.00,348.00 Z
           M 94.00,353.00
           C 94.00,353.00 95.00,354.00 95.00,354.00
             95.00,354.00 95.00,353.00 95.00,353.00
             95.00,353.00 94.00,353.00 94.00,353.00 Z
           M 97.00,355.00
           C 97.00,355.00 98.00,356.00 98.00,356.00
             98.00,356.00 98.00,355.00 98.00,355.00
             98.00,355.00 97.00,355.00 97.00,355.00 Z
           M 93.00,358.00
           C 93.00,358.00 94.00,359.00 94.00,359.00
             94.00,359.00 94.00,358.00 94.00,358.00
             94.00,358.00 93.00,358.00 93.00,358.00 Z
           M 114.00,365.00
           C 114.00,365.00 115.00,366.00 115.00,366.00
             115.00,366.00 115.00,365.00 115.00,365.00
             115.00,365.00 114.00,365.00 114.00,365.00 Z
           M 289.00,366.00
           C 289.00,366.00 290.00,367.00 290.00,367.00
             290.00,367.00 290.00,366.00 290.00,366.00
             290.00,366.00 289.00,366.00 289.00,366.00 Z
           M 290.00,369.00
           C 290.00,369.00 291.00,370.00 291.00,370.00
             291.00,370.00 291.00,369.00 291.00,369.00
             291.00,369.00 290.00,369.00 290.00,369.00 Z
           M 129.00,374.00
           C 129.00,374.00 130.00,375.00 130.00,375.00
             130.00,375.00 130.00,374.00 130.00,374.00
             130.00,374.00 129.00,374.00 129.00,374.00 Z
           M 266.00,374.00
           C 266.00,374.00 267.00,375.00 267.00,375.00
             267.00,375.00 267.00,374.00 267.00,374.00
             267.00,374.00 266.00,374.00 266.00,374.00 Z
           M 134.00,375.00
           C 134.00,375.00 135.00,376.00 135.00,376.00
             135.00,376.00 135.00,375.00 135.00,375.00
             135.00,375.00 134.00,375.00 134.00,375.00 Z
           M 256.00,376.00
           C 256.00,376.00 257.00,377.00 257.00,377.00
             257.00,377.00 257.00,376.00 257.00,376.00
             257.00,376.00 256.00,376.00 256.00,376.00 Z
           M 241.00,380.00
           C 241.00,380.00 242.00,381.00 242.00,381.00
             242.00,381.00 242.00,380.00 242.00,380.00
             242.00,380.00 241.00,380.00 241.00,380.00 Z
           M 166.00,389.00
           C 166.00,389.00 167.00,390.00 167.00,390.00
             167.00,390.00 167.00,389.00 167.00,389.00
             167.00,389.00 166.00,389.00 166.00,389.00 Z
           M 170.00,390.00
           C 170.00,390.00 171.00,391.00 171.00,391.00
             171.00,391.00 171.00,390.00 171.00,390.00
             171.00,390.00 170.00,390.00 170.00,390.00 Z" />
            </SvgIcon>
        );
    }
}
